/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { View } from 'react-native-web';
import { connect } from 'react-redux';

import { Container, Row, Col } from 'reactstrap';

import LoadingModal from 'Components/LoadingModal';
import UpdatePassword from 'Containers/User/Components/UpdatePassword';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';

import getMemberPoints from 'Redux/slices/user/controllers/getMemberPoints';
import Utils from 'Lib/Utils';
import { get } from 'http';
import {
    UserContainer,
    UserTitle,
    UserTabTittle,
    UserTabContainer,
    UserTab,
    UserTabSelected,
    UserTabList,
    UserTabRowCointainer,
    LogoutTitle,
    TabMobileView,
    pointsText,
    IconStyle,
} from './Styles/MainStyles';
import { Person, OrderHistoryIcon, Setting, Logout } from '../../Icons/Icons';
import Account from './Tabs/Account';
import OrderHistory from './Tabs/OrderHistory';

interface UserProps {
    memberPoints: number;
    logoutLoading: boolean;
    logoutError: string;
    logout(): void;
}

const User = (props: UserProps) => {
    const TABS = ['account', 'account history', 'settings'];
    const [selectedTab, setselectedTab] = useState(TABS[0]);

    const { logoutLoading, logoutError, memberPoints } = props;

    const onLogout = () => {
        const { logout } = props;
        logout();
    };

    return (
        <View>
            <Container fluid css={UserContainer}>
                <Row css={UserTitle}> Account</Row>
                <Row>
                    <p css={pointsText}>
                        Member Points:
                        {' '}
                        {memberPoints}
                    </p>
                </Row>

                <Row className='justify-content-center'>
                    <Col xs='3' md='4' lg='3' className='border-right d-none d-sm-flex' css={UserTabContainer}>
                        <Row xs='1'>
                            <ul css={UserTabList}>
                                <li>
                                    <div
                                        onClick={() => setselectedTab(TABS[0])}
                                        onKeyPress={() =>
                                            setselectedTab(TABS[0])}
                                        role='button'
                                        tabIndex={0}
                                        css={UserTabRowCointainer}
                                    >
                                        <Row
                                            css={
                                                selectedTab === TABS[0]
                                                    ? UserTabSelected
                                                    : UserTab
                                            }
                                        >
                                            {/* <Person /> */}
                                            <img src='/assets/icons/Account.svg' alt='account' css={IconStyle} />
                                            <span css={UserTabTittle} className='d-none d-sm-block'>
                                                Account
                                            </span>
                                        </Row>
                                    </div>
                                </li>

                                <li>
                                    <div
                                        onClick={() => setselectedTab(TABS[1])}
                                        onKeyPress={() =>
                                            setselectedTab(TABS[1])}
                                        role='button'
                                        tabIndex={0}
                                        css={UserTabRowCointainer}
                                    >
                                        <Row
                                            css={
                                                selectedTab === TABS[1]
                                                    ? UserTabSelected
                                                    : UserTab
                                            }
                                        >

                                            <img src='/assets/icons/Cart.svg' alt='order' css={IconStyle} />
                                            <span css={UserTabTittle} className='d-none d-sm-block'>
                                                Order History
                                            </span>
                                        </Row>
                                    </div>
                                </li>

                                <li>
                                    <div
                                        onClick={() => setselectedTab(TABS[2])}
                                        onKeyPress={() =>
                                            setselectedTab(TABS[2])}
                                        role='button'
                                        tabIndex={0}
                                        css={UserTabRowCointainer}
                                    >
                                        <Row
                                            css={
                                                selectedTab === TABS[2]
                                                    ? UserTabSelected
                                                    : UserTab
                                            }
                                        >

                                            <img src='/assets/icons/Key.svg' alt='Password' css={IconStyle} />
                                            <span css={UserTabTittle} className='d-none d-sm-block'>
                                                Change Password
                                            </span>
                                        </Row>
                                    </div>
                                </li>

                                <li>
                                    <div
                                        onClick={onLogout}
                                        onKeyPress={onLogout}
                                        role='button'
                                        tabIndex={0}
                                        css={UserTabRowCointainer}
                                    >
                                        <Row
                                            css={UserTab}
                                        >
                                            <img src='/assets/icons/Logout.svg' alt='Logout' css={IconStyle} />
                                            <span css={LogoutTitle} className='d-none d-sm-block'>
                                                Logout
                                            </span>
                                        </Row>
                                    </div>
                                </li>
                            </ul>
                        </Row>
                    </Col>

                    <Row css={TabMobileView} className='d-flex d-sm-none justify-content-center'>
                        <div
                            onClick={() => setselectedTab(TABS[0])}
                            onKeyPress={() =>
                                setselectedTab(TABS[0])}
                            role='button'
                            tabIndex={0}
                        >
                            <Row
                                css={
                                    selectedTab === TABS[0]
                                        ? UserTabSelected
                                        : UserTab
                                }
                            >
                                <Person />
                            </Row>
                        </div>
                        <div
                            onClick={() => setselectedTab(TABS[1])}
                            onKeyPress={() =>
                                setselectedTab(TABS[1])}
                            role='button'
                            tabIndex={0}
                        >
                            <Row
                                css={
                                    selectedTab === TABS[1]
                                        ? UserTabSelected
                                        : UserTab
                                }
                            >
                                <img src='/assets/icons/Cart.svg' alt='order' />
                            </Row>
                        </div>
                        <div
                            onClick={() => setselectedTab(TABS[2])}
                            onKeyPress={() =>
                                setselectedTab(TABS[2])}
                            role='button'
                            tabIndex={0}
                        >
                            <Row
                                css={
                                    selectedTab === TABS[2]
                                        ? UserTabSelected
                                        : UserTab
                                }
                            >
                                <img src='/assets/icons/Key.svg' alt='Password' />
                            </Row>
                        </div>
                        <div
                            onClick={onLogout}
                            onKeyPress={onLogout}
                            role='button'
                            tabIndex={0}
                        >
                            <Row
                                css={
                                    selectedTab === TABS[3]
                                        ? UserTabSelected
                                        : UserTab
                                }
                            >
                                <Logout />
                            </Row>
                        </div>
                    </Row>

                    <Col xs='12' sm='9' md='8' lg='9' fluid>
                        {selectedTab === TABS[0] && <Account />}
                        {selectedTab === TABS[1] && <OrderHistory />}
                        {selectedTab === TABS[2] && <UpdatePassword />}
                    </Col>
                </Row>
                <LoadingModal loading={logoutLoading} />
            </Container>
        </View>
    );
};

const mapStateToProps = (state: RootState) => ({
    logoutLoading: Selectors.getAuthLogoutAttempting(state),
    logoutError: Selectors.getAuthLogoutError(state),
    memberPoints: Selectors.getUserMemberPoints(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    logout: () => dispatch(Actions.authLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
